import React, { Fragment, useState } from 'react'
import { Button, Menu, makeStyles } from '@material-ui/core'
import ArrowDropDownIcon from 'components/material-symbol/icons/ArrowDropDown'

const useStyles = makeStyles(() => ({
  menu: {
    boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.12)',
  },
}))

export default function ButtonMenu({
  label,
  children,
  buttonProps,
  render,
  ...other
}) {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  return (
    <Fragment>
      <Button
        color="primary"
        aria-controls="customized-menu"
        aria-haspopup="true"
        onClick={handleClick}
        endIcon={<ArrowDropDownIcon />}
        {...buttonProps}
      >
        {label}
      </Button>

      <Menu
        elevation={0}
        getContentAnchorEl={null}
        keepMounted
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        PopoverClasses={{ paper: classes.menu }}
        {...other}
      >
        {render ? render({ handleClose }) : children}
      </Menu>
    </Fragment>
  )
}
